TS.ns('WL');

WL.dictionaryEditViewModel = new Class({
    Extends: TS.domain.EditDomain,

    initialize: function (config) {
        var me = this,
            dictionaryItemList;

        me.parent(config);

        dictionaryItemList = me.getDomainProperty('dgDictionaryItemCollection_Property');
        if (dictionaryItemList != null) {
            dictionaryItemList.AllowAdd(!me.Document.IsReadOnly());
            dictionaryItemList.on('cellBeginEdit', me.onDictionaryGridBeginEdit);
        }
    },

    onDictionaryGridBeginEdit: function (e) {
        var me = this,
            owner = me._getOwner();

        if (owner.Document.IsReadOnly()) {
            if (e.fieldName != 'Implicit' && e.fieldName != 'IsActive' && e.fieldName != 'OrderNo')
                e.preventDefault();
        }
    },

});